import { render, staticRenderFns } from "./NoNav.vue?vue&type=template&id=681d7c12"
import script from "./NoNav.vue?vue&type=script&lang=js"
export * from "./NoNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports